import { useTranslation } from 'react-i18next';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal/Modal';
import { useBookMeetingModal } from '../../../context/bookMeetingModalContext';
import { formatNumber } from '../../../core/helpers';
import { ReactComponent as FolderIcon } from '../../../icons/folder-yellow.svg';
import './FCTransfersModal.scss';

interface Props {
  isModalOpened: boolean;
  closeModal: () => void;
  transactions: number;
}

export default function FCTransfersModal({
  isModalOpened,
  closeModal,
  transactions,
}: Props) {
  const { t } = useTranslation();
  const { openModal: openMeetingModal } = useBookMeetingModal();
  return (
    <Modal isOpened={isModalOpened} close={closeModal} title={t('Information')}>
      <div className='mx-3 pt-3 pb-4 px-3'>
        <div className='fw-800 Text'>{t('FC-Transfer transactions')}</div>
        <div className='mb-3'>
          {t(
            "Sometimes local tax advisors don't have information about these transactions and don't include them to local filings. It can lead to penalties during additional checks by tax authorities."
          )}
        </div>
        <div className='mb-4'>
          {t('You have')}
          &nbsp;
          <span className='fw-600'>
            {formatNumber(transactions)} {t('transactions_modal')}
          </span>
          &nbsp;
          {t('that must be specified in local filing reports.')}
        </div>
        <div className='FCTransfersModal__card d-flex flex-column align-items-center justify-content-center'>
          <FolderIcon />
          <div
            className='mt-2 text-center fw-800 mb-3'
            style={{
              maxWidth: 400,
            }}
          >
            {t(
              'countX can export all needed data files for your Tax Advisor to fullfil all required VAT documents'
            )}
          </div>
          <Button
            onClick={() => {
              closeModal();
              openMeetingModal();
            }}
          >
            {t('Book a consultation')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
